module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1067.cea8d2a9.png";